/**
 * Toistuvat luokkayhdistelmät yhdessä paikassa.
 *
 * Ei komponenttikirjastoa: hallintanäkymissä on kymmeniä kenttiä, ja
 * pelkkä merkkijono riittää pitämään ne yhdenmukaisina ilman, että
 * jokainen kenttä kääritään omaan komponenttiinsa.
 */

export const kentta =
  'border-reuna bg-pinta text-teksti w-full rounded-md border px-3 py-2 text-sm disabled:opacity-50';

/** Brändin punainen täyttö: sama punainen molemmissa teemoissa (styles.css). */
export const nappiEnsisijainen =
  'bg-brandi hover:bg-brandi-syva rounded-md px-4 py-2 text-sm font-medium text-white transition-colors disabled:opacity-50 disabled:hover:bg-brandi';

export const nappiToissijainen =
  'border-reuna text-teksti hover:border-reuna-vahva rounded-md border px-4 py-2 text-sm disabled:opacity-50';

/**
 * Taulukon rivin nimi linkkinä. Muste eikä punainen: sarakkeellinen
 * punaista tekstiä näyttäisi virhelistalta, ja punainen on varattu sille,
 * mihin katseen halutaan osuvan. Alleviivaus kertoo, että nimi on linkki;
 * punainen tulee esiin vasta osoitettaessa.
 */
export const riviLinkki =
  'text-teksti decoration-reuna-vahva hover:text-korostus hover:decoration-korostus underline underline-offset-4 transition-colors';

export const kortti = 'border-reuna bg-pinta-korotettu rounded-lg border p-4';

/**
 * Osion tunniste: tasalevyinen versaali, kuten esittelyn kalvojen
 * yläotsikot. Tasalevyinen erottaa tunnisteen sisällöstä ilman viivaa.
 */
export const otsikkoRivi =
  'text-teksti-vaimea font-mono text-[0.6875rem] font-medium uppercase tracking-[0.12em]';
